import { useTranslation } from "react-i18next";
import { Page } from "@/components/Page";
import { PageSection, SettingsList, SettingsRow } from "@/components/section/SectionBlocks";
import { Text } from "@/components/Text";
import { ApiKeysSection } from "./ApiKeysSection";

export function SecurityPage() {
  const { t } = useTranslation("settings");
  return (
    <Page title={t("security.title")} subtitle={t("security.subtitle")}>
      <PageSection title={t("security.signIn.title")}>
        <SettingsList>
          <SettingsRow label={t("security.signIn.method")} description={t("security.signIn.methodDescription")}>
            <Text variant="body-sm" tone="secondary" className="md:text-right">
              {t("security.signIn.provider")}
            </Text>
          </SettingsRow>
          <SettingsRow label={t("security.signIn.password")} description={t("security.signIn.passwordDescription")}>
            <Text variant="body-sm" tone="secondary" className="md:text-right">
              {t("security.signIn.managed")}
            </Text>
          </SettingsRow>
        </SettingsList>
      </PageSection>
      <ApiKeysSection />
    </Page>
  );
}
